import { useCallback, useState } from 'react'

export interface WorkflowParametersModalState {
  hasParameters: boolean | null
  onHasParameters: (has: boolean) => void
  onDirtyChange: (dirty: boolean) => void
  handleHide: () => void
}

export const useWorkflowParametersModal = (workflowId: string, onHide: () => void): WorkflowParametersModalState => {
  const [trackedWorkflowId, setTrackedWorkflowId] = useState(workflowId)
  const [hasParameters, setHasParameters] = useState<boolean | null>(null)
  const [paramsDirty, setParamsDirty] = useState(false)

  if (workflowId !== trackedWorkflowId) {
    setTrackedWorkflowId(workflowId)
    setHasParameters(null)
    setParamsDirty(false)
  }

  const onHasParameters = useCallback((has: boolean) => setHasParameters(has), [])
  const onDirtyChange = useCallback((dirty: boolean) => setParamsDirty(dirty), [])
  const handleHide = useCallback(() => {
    if (paramsDirty && !window.confirm('Discard unsaved parameter changes?')) {
      return
    }
    onHide()
  }, [paramsDirty, onHide])

  return { hasParameters, onHasParameters, onDirtyChange, handleHide }
}
